
import { defineComponent, ref, watch, computed, unref } from 'vue'
import { toShowFormated, toSendFormated } from '@/composables/useNumbers'
import { swapTokens } from '@/services/swap'
import { toHex } from '@/utils/eth-utils'
import useWeb3 from '@/services/web3/useWeb3'
import { createNotification } from '@/services/notification'
import sendTransaction from '@/services/transaction'

export default defineComponent({
  name: 'SwapConfirm',
  props: {
    openModal: { type: Boolean },
    tokenIn: {
      type: Object
    },
    tokenOut: {
      type: Object
    }
  },
  setup(props, { emit }) {
    const modalOpen = ref(props.openModal)
    const loading = ref(false)
    const { wallet } = useWeb3()

    const amountZero = computed(() => {
      // @ts-ignore
      if (Number(props.tokenIn.value.amount) === 0) {
        return true
      }

      return false
    })

    function closeModal() {
      emit('closeModal', false)
    }

    function swapTx() {
      loading.value = true
      return swapTokens({
        // @ts-ignore
        fromTokenAddress: props.tokenIn.value.address,
        // @ts-ignore
        toTokenAddress: props.tokenOut.value.address,
        // @ts-ignore
        amount: props.tokenIn.value.amount,
        // @ts-ignore
        fromAddress: wallet.value.address,
        slippage: 1
      })
        .then(async (res) => {
          const tx = res.data.tx
          delete tx.gas
          delete tx.gasPrice
          tx.value = toHex(tx.value)

          return tx
        })
        .catch((e) => {
          console.log(e)
        })
    }

    async function swap() {
      const tx = await swapTx()

      sendTransaction({ web3: unref(wallet), tx })
        .then((data) => {
          createNotification({
            title: 'Transaction Sent',
            message: data.hash
          })
        })
        .catch((e) => {
          console.log('❌', e)
        })
        .finally(() => {
          loading.value = false
        })
    }

    watch(
      () => props.openModal,
      (val) => {
        modalOpen.value = val
      }
    )
    return {
      props,
      modalOpen,
      closeModal,
      toShowFormated,
      toSendFormated,
      swap,
      amountZero,
      loading
    }
  }
})
